import { WSQueryConfig } from "@ws-react-query";
import { getWorkLog } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";

export const QUERY_WORK_LOG = "QUERY_WORK_LOG";

export const useQueryWorkLog = (
  workLogId: Parameters<typeof getWorkLog>[0],
  config?: WSQueryConfig<Awaited<ReturnType<typeof getWorkLog>>, WSServiceError>
) =>
  useWSQuery([QUERY_WORK_LOG, workLogId], () => getWorkLog(workLogId), config);
